/* eslint-disable no-unused-vars */
import { useLocation, useNavigate } from "react-router-dom";
import { tokens } from "../../styles/theme";
import React, { useEffect, useState } from "react";
import { Box, useTheme, Button } from "@mui/material";
import { Grid } from "@material-ui/core";
import PopupUpdate from "../../component/Popupupdate";
import ProfitEdit from "./Editpayment";
import { DataGridPro } from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import {
  GridFooterContainer,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
  GridPagination,
} from "@mui/x-data-grid";
import * as sweetalert from "sweetalert";

import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import {Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";

import {
  deleteTrip,
  fetchTripBYId
} from "../../redux/tripsSlice";

import dayjs from "dayjs";
import { useRef } from "react";
import {  fetchprofitByid } from "../../redux/profit";

import axios from "axios";
import packageJson from "../../../package.json";
import Controls from "../../component/controls/Controls";
import PopupCreate from "../../component/PopupCreate";
import PathTripForm from "../Complaints/PathTripForm";
import Addpayment from "./Addpayment";
import PopupCreatePayment from "../../component/PopupCreatePayment";
import Editpayment from "./Editpayment";
import { fetchPaymentByid } from "../../redux/payment";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  return (
    <Pagination
      color="primary"
      count={pageCount}
      page={page + 1}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
}

function CustomFooter() {
  return (
    <GridFooterContainer>
      <CustomPagination />
      <GridPagination />
    </GridFooterContainer>
  );
}
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  searchDesign: {
    direction: "rtl",
    marginTop: "0 !important",
    width: "95%",
    flexDirection: "row-reverse",
    paddingRight: "8px",
    height: "45px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.3) !important",
    marginRight: "3px",
  },
  "@media (min-width: 600px) and (max-width:1280px)": {
    searchDesign: {
      marginBottom: "15px",
    },
  },
  filter: {
    display: "flex !important",
    justifyContent: "space-between !important",
    alignItems: "center !important",
    flexWrap: "wrap !important",
    height: "40px !important",
    borderRadius: "5px !important",
  },
  editButton: {
    display: "none",
    flexDirection: "row-reverse",
    color: "#000002 !important",
    fontSize: "20px",
    // fontWeight: "600 !important",
    fontFamily: "beIN",
  },
  deleteButton: {
    display: "flex",
    flexDirection: "row-reverse",
    color: "#F9B917 !important",
    fontSize: "20px ",
    fontFamily: "beIN",
  },
  editImg: {
    width: "15px",
  },
  Marginbox1: {
    maxWidth: "100% !important",
    flexBasis: "100%",
  },
  "& tbody tr:nth-of-type(odd)": {
  backgroundColor: "#f9f9f9",
},
"& tbody tr:nth-of-type(even)": {
  backgroundColor: "#ffffff",
},
});

export default function Type_paymentTable() {
  const [profitss, setProfitss] = useState([]);
  const dispatch = useDispatch();
  const { Profit } = useSelector((state) => state.Profits);
  //Add Permission

  useEffect(() => {
    // Fetch the data using axios or any other method
    const fetchData = async () => {
      try {
        const res = await axios.get(`${BaseUrl}/getAllPaymentType`, {
                  headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
        });
        const result = res.data.data;
       
        
        setProfitss(result);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Handle the 500 error server   error specifically
          localStorage.removeItem("isLoggedIn");
          window.location.reload()
        }
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Call the function to fetch data
  }, []);

  // Rest of your code ...

  const handleToggle = async (id, isActive) => {
    try {
      // Determine the confirmation message based on the current isActive state
      const confirmationMessage =
        isActive == "1"
          ? "هل انت متاكد من ايقاف طريقة الدفع"
          : "هل انت متاكد من تفعيل طريقة الدفع";
  
      // Show confirmation dialog
      const confirmation = await sweetalert({
        title: "تأكيد",
        text: confirmationMessage,
        icon: "warning",
        buttons: {
          cancel: {
            text: "إلغاء",
            value: false,
            visible: true,
            className: "custom-cancel-button",
          },
          confirm: {
            text: "تأكيد",
            value: true,
            className: "custom-confirm-button",
          },
        },
        dangerMode: true,
        className: "alert-div",
      });
  
      // If the user cancels, stop the execution
      if (!confirmation) {
        return;
      }
      const toggledActive = isActive === "1" ? "0" : "1";

      const data = {
        active: toggledActive, // Send the toggled value
      };
  
      // Proceed with the API call
      await axios
        .post(`${BaseUrl}/changeStatusPaymentType/${id}`,data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
          },
        })
        .then((res) => {
          if (res.status === 200) {
            sweetalert({
              text: 'تم التعديل بنجاح',
              icon: "success",
              buttons: {
                confirm: {
                  text: "تم",
                  className: "custom-button-class",
                },
              },
              className: "alert-div",
            }).then(() => {
              window.location.reload();
            });
          } else {
            console.error("Failed to update status");
          }
        });
    } catch (error) {
      // Handle errors
      if (error.response && error.response.status === 403) {
        sweetalert({
          text: "ليس لديك صلاحية للقيام بهذا",
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      } else if (error.response && error.response.status === 401) {
        localStorage.removeItem("isLoggedIn");
        window.location.reload();
      } else {
        const errorMessage =
          error.response?.data?.message || error.response?.data?.data;
        sweetalert({
          text: errorMessage,
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      }
    }
  };


  const location = useLocation();

 


  const [filteredData, setFilteredData] = useState(profitss);
  const currentDateTime = new Date();
  const options = {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  };

  const classes = useStyles();
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopup2, setOpenPopup2] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [recordForEdit11, setRecordForEdit11] = useState(null);
  const [recordForEdit1, setRecordForEdit1] = useState(null);
  const [openPopupStop, setOpenPopupStop] = useState(false);
  const [clickedEmployeeId, setClickedEmployeeId] = useState(null);

 
  function handleOpen() {
    setOpenPopup(true);
    setRecordForEdit(null);
  }
  function handleE(id) {
    setOpenPopup2(true);
    setRecordForEdit1(null);
    setClickedEmployeeId(id);
    dispatch(fetchPaymentByid(id));
  }

  const onHandleReset = () => {
    setFilteredData(Profit);
  };

  function EditToolbar(props) {
    return (
      <div className="trip">
  
    
        <Grid container xs={12} className={classes.Marginbox1}>
        <Grid lg={3} md={4} sm={3} className={classes.AddDesign}>
        <div className="bottonFullwidth1">
          <Controls.Button
            type="submit"
            text="إضافة"
            onClick={() => {
              setOpenPopup(true);
              setRecordForEdit(null);
            }}
          />
        </div>
        </Grid>
              <PopupCreatePayment
                  title="طريقة دفع جديدة"
                  openPopup={openPopup}
                  setOpenPopup={setOpenPopup}
                
                >
                  <Addpayment  recordForEdit={recordForEdit} />
                </PopupCreatePayment>
              
        </Grid>
      </div>
    );
  }

  EditToolbar.propTypes = {
    setRowModesModel: PropTypes.func.isRequired,
  };

  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [openPopup1, setOpenPopup1] = useState(false);
  const [openConfigPopup, setOpenConfigPopup] = useState(false);
  const [selectedConfigData, setSelectedConfigData] = useState(null);

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };


  function handleClickEdit(id) {
    setClickedEmployeeId(id);
    dispatch(fetchTripBYId(id));
  }
  
  const handleConfigClick = (configData) => {
    setSelectedConfigData(configData); // Store the config data
    setOpenConfigPopup(true); // Open the popup
  };
  const handleOpenPopup = (configData) => {
    setSelectedConfigData(configData); // Set the config data for the selected row
    setOpenConfigPopup(true); // Open the dialog
  };

  
  const handleClosePopup = () => {
    setOpenConfigPopup(false); // Close the popup
    setSelectedConfigData(null); // Clear the data
  };

  function handleDelete(id) {
    setConfirmDialog({
      isOpen: true,
      title: "أنت على وشك حذف هذه الرحلة",
      img: "img/emp/Inbox cleanup-rafiki.svg",
      onConfirm: () => {
        dispatch(deleteTrip(id));
      },
    });
  }
  
  const rowsWithRowNumber = profitss.map((row, index) => ({
    ...row,
    id: row.id,
    rowNumber: row.id ,
  }));
  const getPageSize = () => {
    if (window.innerWidth < 992) {
      return 5; // Set a smaller pageSize for smaller screens
    } else if (window.innerWidth < 1566) {
      return 7; // Default pageSize for larger screens
    } else if (window.innerWidth < 1760) {
      return 8; // Default pageSize for larger screens
    } else if (window.innerWidth < 1930) {
      return 13; // Default pageSize for larger screens
    }
  };
  useEffect(() => {
    getPageSize();
  });
  const columns = [
    {
      field: "type_name_en",
      sortable: false,
      headerName: "اسم طريقة الدفع",
      resizable: true,
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "type_name_ar",
      sortable: false,
      headerName: "اسم طريقة الدفع بالعربي",
      resizable: true,
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "config",
      sortable: false,
      resizable: true,
      headerName: "الإعدادات",
      minWidth: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Button
        onClick={() => handleOpenPopup(params.row.config)} // Pass the config data to the dialog
      >
          <img
            src="img/eye.svg" // Replace with the actual path to your eye icon
            alt="Eye Icon"
            style={{ width: "20px", height: "20px" }}
          />
        </Button>
      ),
    },
    {
      field: "active",
      sortable: false,
      resizable: true,
      headerName: "حالة الدفع",
      minWidth: 80,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
      
        
        <span style={{ fontWeight: "bold", color: params.value == 1 ? "green" : "red" }}>
          {params.value == 1 ? "مفعل" : "غير مفعل"}
      
        </span>
      ),
    },
    {
      field: "action",
      headerAlign: "center",
      headerName: "العمليات",
      resizable: true,
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      renderCell: (params) => {
        const id = params.row.id;
        const isactive = params.row.active;
        return (
          <Box>

            <Button
              className={classes.editButton}
              onClick={() => {
                handleE(id);
              }}
            >
              <img
                src="img/edit.svg"
                className={classes.editImg}
                alt="edit icon"
              ></img>
            </Button>
            <FormControlLabel
            class="check-user"
                                 control={
                                   <Switch
                                     
                                     value={isactive}
                                     checked={isactive == "1"}
                                     onChange={() => handleToggle(id,isactive)}
                                     color="warning"
                                    
                                    
                                   />
                                 }
                               />
            <PopupCreatePayment
              title=" تعديل طريقة الدفع"
              openPopup={openPopup2}
              setOpenPopup={setOpenPopup2}
            >
              <Editpayment
                id_company={clickedEmployeeId}
                recordForEdit={recordForEdit11}
              />
            </PopupCreatePayment>
          </Box>
        );
      },
    },
  ];
  

  return (
    <Box>
      <Box
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },

          "& .MuiDataGrid-columnHeaders": {
            borderBottom: "none",
            fontSize: "15px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "15px !important",
            color: `${colors.primary[1000]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
        }}
      >
      <Dialog open={openConfigPopup} onClose={handleClosePopup} maxWidth="sm" fullWidth>
      <DialogTitle style={{textAlign:"right"}}>الإعدادات</DialogTitle>
      <DialogContent>
        {selectedConfigData ? (
          <Box style={{textAlign:"right"}}>
            <Typography variant="h6" gutterBottom>
              تفاصيل الإعدادات
            </Typography>
            <Box
              component="table"
              sx={{
                width: "100%",
                borderCollapse: "collapse",
                "& th, & td": {
                  border: "1px solid #ddd",
                  padding: "8px",
                  textAlign: "left",
                },
                "& th": {
                  backgroundColor: "#f4f4f4",
                  fontWeight: "bold",
                },
              }}
            >
              <thead>
                <tr>
                  <th>الحقل</th>
                  <th>القيمة</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(selectedConfigData).map(([key, value]) => (
                  <tr key={key}>
                    <td>{key}</td>
                    <td>
                      {Array.isArray(value)
                        ? value.join(", ") // Display arrays as comma-separated values
                        : typeof value === "object"
                        ? JSON.stringify(value, null, 2) // Handle nested objects
                        : value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Box>
          </Box>
        ) : (
          <Typography>لا توجد بيانات لعرضها</Typography>
        )}
      </DialogContent>
    </Dialog>
    
          <DataGridPro
            rows={rowsWithRowNumber || []}
            columns={columns}
            sx={{ overflowX: "scroll" }}
            className="field-table1"
            editMode="row"
            pageSize={getPageSize()}
            pagination
            rowModesModel={rowModesModel}
            onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
            onRowEditStart={handleRowEditStart}
            onRowEditStop={handleRowEditStop}
            components={{
              Toolbar: EditToolbar,
              Footer: CustomFooter,
            }}
            localeText={{
              footerRowSelected: CustomPagination,
            }}
          />
    
      </Box>
    </Box>
  );
}
